/**
 * Indaleti API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ABSENT counts as 0; EXCUSED is left out of the learner\'s result.
 */
export const MarkStatus = {
    Recorded: 'RECORDED',
    Absent: 'ABSENT',
    Excused: 'EXCUSED'
} as const;
export type MarkStatus = typeof MarkStatus[keyof typeof MarkStatus];

